/* eslint-disable */

export class Item {
    /** @type {string} eg. "Hotel Golden Odyssey", offer name */
    item_name;
    /** @type {string} eg. "a7e43d8fadb22fbca2ab501df63e7cdd22dbbf6409820fb5dbd347ad8696993b", offer id/sku */
    item_id;
    /** @type {float} eg. 3230.00, offer price */
    price;
    /** @type {string} eg. "Rodos", offer category */
    item_category;
    /** @type {string} eg. "All inclusive", offer variant */
    item_variant;
    /** @type {string} eg. "Główna", offer list name  */
    item_list_name;
    /** @type {string} eg. "1", offer list id  */
    item_list_id;
    /** @type {int} eg. "0", list position  */
    index;
    /** @type {int} eg. "1", offers number */
    quantity;
    /** @type {string} eg. "GRECJA50", offer amount */
    coupon;
    /** @type {float} eg. 500.00, offer discount */
    discount;
    /** @type {string} eg. "Aparthotel", hotel type */
    hotel_type;
    /** @type {string} eg. "RHOCORA", hotel id */
    hotel_id;
    /** @type {string} eg. "Last Second", promotion name */
    promotion;
    /** @type {int} eg. 2, adults number  */
    adults;
    /** @type {int} eg. 1, children number  */
    children;
    /** @type {string} eg. 20230703, departure date  */
    departure_date;
    /** @type {string} eg. 20230703, return date  */
    return_date;
    /** @type {integer} eg. 7, duration  */
    duration;
    /** @type {string} eg. 4.5, hotel standard  */
    hotel_standard;
    /** @type {string} eg. "RAJ DLA DZIECI", hotel category  */
    offer_type;
    /** @var {Item} item */
    static getItem(id, name) {
        const item = new Item()
        item.item_name = name
        item.item_id = id

        return item
    }
}

export class DataLayerEvent {
    /** @type {string} */
    event;
    /** @type {ItemListEcommerce|PaymentInfoEcommerce|PromotionEcommerce|PurchaseEcommerce|ServiceEcommerce} */
    ecommerce;
    constructor(name) {
        this.event = name
    }

    /**
     * 
     * @param {Partial<Item>} item 
     * @returns 
     */
    static purchase(item) {
        const event = new DataLayerEvent('purchase')
        const ecommerce = new PurchaseEcommerce()
        const items = []
        item = item || new Item()
        items.push(item)
        event.ecommerce = ecommerce
        ecommerce.items = items

        return [event, ecommerce, ...items]
    }

    /**
     * 
     * @param {'view_item_list' | 'select_item'} type is view_item_list or select_item
     * @param {Array<Partial<Item>>} items 
     * @returns 
     */
    static itemList(type, items) {
        const event = new DataLayerEvent(type)
        const ecommerce = new ItemListEcommerce()
        event.ecommerce = ecommerce
        items = items || []
        ecommerce.items = items
        return [event, ecommerce, ...items]
    }

    /**
     * 
     * @param {'view_item' | 'begin_checkout'} type is view_item or begin_checkout
     * @param {Partial<Item>} item 
     * @returns 
     */
    static itemEvent(type, item) {
        const event = new DataLayerEvent(type)
        const ecommerce = new ItemListEcommerce()
        event.ecommerce = ecommerce
        const items = []
        items.push(item || new Item())
        ecommerce.items = items
        return [event, ecommerce, ...items]
    }

    /**
     * 
     * @param {Partial<Item>} data 
     * @returns 
     */
    static selectPromotion(data) {
        const event = new DataLayerEvent('select_promotion')
        const ecommerce = new ItemEcommerce()
        event.ecommerce = {...ecommerce, ...data}
        return [event, ecommerce]
    }

    /**
     * 
     * @param {Partial<Item>} data 
     * @returns 
     */
    static viewPromotion(data) {
        const event = new DataLayerEvent('view_promotion')
        const ecommerce = new ItemEcommerce()
        event.ecommerce = {...ecommerce, ...data}
        return [event, ecommerce]
    }

    /**
     * 
     * @param {'view_promotion' | 'select_promotion'} type is view_promotion or select_promotion
     * @param {Partial<Item>} item 
     * @returns 
     */
    static payment(item, paymentMethod) {
        const event = new DataLayerEvent('add_payment_info')
        const ecommerce = new PaymentInfoEcommerce()
        event.ecommerce = ecommerce
        const items = []
        items.push(item || new Item())
        ecommerce.items = items
        ecommerce.currency = 'PLN'
        ecommerce.value = item.price * item.quantity
        ecommerce.payment_type = paymentMethod

        return [event, ecommerce, ...items]
    }

    /**
     * 
     * @param {Partial<Item>} item 
     * @returns 
     */
    static service(item) {
        const event = new DataLayerEvent('add_service')
        const ecommerce = new ItemEcommerce()
        event.ecommerce = ecommerce
        const items = []
        items.push(item || new Item())
        ecommerce.items = items

        return [event, ecommerce, ...items]
    }
}

export class Ecommerce {
    /** @type {Array<Item>}  */
    items;
    constructor() {
        this.items = [];
    }
}
/**
 * Use in View Item List, Select Item
 * One distinction: Select item list only consists of selected item
 */
export class ItemListEcommerce extends Ecommerce {
    /** @type {string} eg. "Główna"  */
    item_list_name;
    /** @type {string} eg. "1"  */
    item_list_id;
    constructor() {
        super()
    }
}
/**
 * Use in View Item, Begin Checkout
 */
export class ItemEcommerce extends Ecommerce {
    /** @type {'PLN' | 'EUR'}} can be any other currency code */
    currency;
    /** @type {float} eg. 3230.00  */
    value;
    constructor() {
        super()
    }
}

export class PaymentInfoEcommerce extends ItemEcommerce {
    /** @type {string} eg. "BLIK"  */
    payment_type;
    constructor() {
        super()
    }
}

export class PromotionEcommerce extends Ecommerce {
    promotion_id;
    promotion_name;
    creative_name;
    creative_slot;
    constructor() {
        super()
    }
}

export class ServiceEcommerce extends ItemEcommerce {
    service_type;
    service_price;
    constructor() {
        super()
    }
}
/**
 * Used in Purchase Success and Purchase Failure
 */
export class PurchaseEcommerce extends ItemEcommerce {
    /** @type {string} eg. "2812202"  */
    transaction_id;
    /** @type {float} eg. 742.90  */
    tax;
    /** @type {float} eg. "GRECJA50", used coupon */
    coupon;
    constructor() {
        super()
        this.tax = 0
    }
}

const eventTypes = [
    'view_item_list',
    'select_item',
    'view_item',
    'begin_checkout',
    'add_payment_info',
    'purchase',
    'failed_purchase',
    'view_promotion',
    'select_promotion',
    // TODO ?
    'add_service',
]

export function pushEvent(event) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(JSON.parse(JSON.stringify(event)))
}

/**
 * 
 * @param {Exclude<PurchaseEcommerce, 'items'} purchaseData 
 * @param {Partial<Item>} item 
 */
export function appendPurchaseDataLayer(purchaseData, item) {
    const [event, ecommerce] = new DataLayerEvent.purchase(item)
    for (const k in purchaseData) {
        ecommerce[k] = purchaseData[k]
    }
    pushEvent(event)
}


// WEBPACK FOOTER //
// ./src/modules/datalayer/helpers.js